import {
    resolve
} from "path"

class getCodeAndNumber {
    constructor(invoiceOpenService) {
        this.invoiceOpenService = invoiceOpenService
        this.ukeyList = JSON.parse(localStorage.user_info).sysUkeyList
    }
    getUkeyList(list) {
        return new Promise((resolve) => {
            let ukeyIdList = []
            let hasOtherType = false
            const invType = list[0].invType
            list.forEach(item => {
                ukeyIdList.push(item.ukeyId)
                if (item.invType != invType) hasOtherType = true
            })
            ukeyIdList = Array.from(new Set(ukeyIdList))
            const ukeyList = []
            this.ukeyList.forEach(item => {
                ukeyIdList.forEach(i => {
                    if (item.ukeyId == i) ukeyList.push(item)
                })
            })
            if (hasOtherType) {
                resolve(ukeyList, '')
            } else {
                resolve(ukeyList, invType)
            }
        })
    }
    getStr(ukey, invType = '') {
        return new Promise(resolve => {
            let str = ''
            if (!invType && invType != '0') {
                this.invoiceOpenService.getStockByUkey(this.ukeyList, ukey.ukeyId).then(arr => {
                    arr.forEach(r => {
                        if (r.invType == 2) {
                            str += `<br>开票点：${ukey.ukeyName}，普通发票，起始开具代码：${r.invoiceCode}，号码：${r.invoiceNumber}`
                        } else if (r.invType == '0') {
                            str += `<br>开票点：${ukey.ukeyName}，专用发票，起始开具代码：${r.invoiceCode}，号码：${r.invoiceNumber}`
                        }
                    })
                    resolve(str)
                },()=>{
                    resolve(str)
                })
            } else {
                this.invoiceOpenService.getStockByUkey(this.ukeyList, ukey.ukeyId, invType).then(r => {
                    str = `<br>开票点：${ukey.ukeyName}，起始开具代码：${r.invoiceCode}，号码：${r.invoiceNumber}`
                    resolve(str)
                },()=>{
                    resolve(str)
                })
            }
        })
    }
}
getCodeAndNumber.$inject = ['invoiceOpenService']
export default getCodeAndNumber


// WEBPACK FOOTER //
// ./src/common/services/getCodeAndNumber.js